export const WARNING =
  "You haven't yet provided Ideal4Finance with bank details - please add them to ensure we can pay you";
